import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=b01e12ae&scoped=true&"
import script from "./Heading.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Heading.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Heading.vue?vue&type=style&index=0&id=b01e12ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01e12ae",
  null
  
)

export default component.exports